<template>
    <div class="page" @scroll="handleScroll" ref="scrollRef" style="height: 100vh; overflow: auto;" :style="unLoginFlagFun()&&!showWater?'overflow: hidden !important;max-height: 100vh !important;':''">
        <panel v-if="noJump" :extinfo="extinfo" ref="panel" :wapTitle="''" :appLink="appLink" :spreadID="'0'" :showNav="false" @gotoApp="gotoApp" :isApp="false"></panel>
        <div class="liveStatus liveIng" v-if="info.live_info.bid_type==1&&info.live_info.bid_status==2" @click="jumpLink( 'https://m-auction.artron.net/trade/auction/live/' + info.live_info.special_id+'?cloud_special_id='+info.CloudSpecialId,10,1)">
            <lottie class="liveIconSty" :options="heartOptions3" :height="0.7" :width="0.7" />
            <div>直播中</div>
        </div>
        <header v-if="noJump" class="header greenHeader">
            <a href="javascript:;" class="goBack" @click="goBack()" v-if="!isWx && !from"></a>
            <span class="icon_share" @click="alertInfo" v-if="!isWx && from!=1"></span>
            <!-- <div class="searchBtn" @click="toSearch">
                搜索拍品
            </div> -->
            <div @click.stop="followFun(info)" class="followBox">
                <img v-if="info.isFocus==1" src="../../assets/img/Group 164@2x.png">
                <img v-if="info.isFocus==0" src="../../assets/img/Group 163@2x.png">
            </div>
            <h3></h3>
        </header>
        <header v-if="!noJump" style="height: 2.2rem; width: 100%; background: #35bd7d"></header>
        <div class="imgBg">
            <div class="bgGary"> </div>
            <img :src="detailInfopic">
        </div>
        <div class="aucInfos">
            <dl class="fix">
                <dt>
                    <div class="imgCenter">
                        <!-- <img src="../../assets/img/avator.jpeg" alt="" /> -->
                        <img :src="detailInfopic" alt="" />
                        <template v-if="info.live_info.have_live > 0&&info.live_info.bid_type!=1">
                            <a :href="
                                    'https://m-auction.artron.net/live/detail?id=' +
                                    info.live_info.lives[0].live_id +
                                    '&special_id=' +
                                    info.live_info.special_id
                                ">
                                <span class="live" v-if="info.live_info.live_status == 2">正在直播</span>
                                <span class="review" v-else-if="info.live_info.live_status == 4 && info.live_info.have_review == 1">直播回放</span>
                                <span class="review" v-else-if="info.live_info.live_status == 0 || info.live_info.live_status == 1">即将开播</span>
                            </a>
                        </template>
                    </div>
                </dt>
                <dd @click="toSpecialDetail()">
                    <h3 class="name">{{ detailInfoName }}</h3>
                    <div class="tags" v-if="
                                    info &&
                                    info.live_info &&
                                    info.live_info.label_list.length
                                ">
    
                        <span class="tag" :class="{tagStyle:flag.style==1}" v-for="(flag,k) in info.live_info.label_list" :key="k">{{ flag.name }}</span>
                    </div>
                    <div class="items">
                        <template v-for="(item, index) in extraInfo">
                            <p :key="index" v-if="item.text" :style="item.label=='文物许可'?'color: #FF9720;':''">
                                <span>{{ item.label }}:</span>{{ item.text }}
                            </p>
                        </template>
                        <p v-if="info.watch_num>0&&info.live_info.bid_type>0">
                            <span>围观次数:</span>{{ info.watch_num }}
                        </p>
                    </div>
                </dd>
            </dl>
        </div>
    
        <div class="specialSubjectBox" v-if="info.article_list.length>0||info.live_info.bid_type==1||info.live_info.bid_type==2">
            <div class="greenTip">
               <img style="width: 0.59rem;margin-right: 0.35rem;" src="../../assets/img/greenTip_icon.png" alt=""> 参拍大额拍品，请提前&nbsp;1&nbsp;个工作日充值
            </div>
            <div class="subjectBox">
    
                <div v-if="info.live_info.bid_type==1||info.live_info.bid_type==2" class="bidTypeBox">
                    <div class="bidTitleBox">
                        <div style="margin-right:0.3rem" v-if="info.live_info.bid_type==1&&info.live_info.bid_status==2||info.live_info.bid_type==2&&info.live_info.bid_status==2">
                            <lottie :options="heartOptions2" :height="1" :width="1" />
                        </div>
    
                        <img class="bitTypeIcon" v-if="info.live_info.bid_type==1&&info.live_info.bid_status==2" src="@/assets/img/bid_type1.png" alt="">
                        <img class="bitTypeIcon" v-if="info.live_info.bid_type==1&&info.live_info.bid_status==1" src="@/assets/img/bid_type4.png" alt="">
                        <img class="bitTypeIcon" v-if="info.live_info.bid_type==2&&info.live_info.bid_status==2" src="@/assets/img/bid_type2.png" alt="">
                        <img class="bitTypeIcon" v-if="info.live_info.bid_type==2&&info.live_info.bid_status==1" src="@/assets/img/bid_type3.png" alt="">
                        <img class="bitTypeIcon" v-if="info.live_info.bid_status==3" src="@/assets/img/bid_type5.png" alt="">
                        <span class="bidText">
                            {{info.bid_at}}
                        </span>
                        <div v-if="info.live_info.bid_status==1&&info.live_info.is_delay!=1" class="bidkaiboBtn" @click="gotoApp(3,1)">{{info.live_info.bid_type==1?'开播':'开拍'}}提醒</div>
                    </div>
                    <div class="bidMainTextBox">
                        <div><span>{{info.art_total}}</span>拍品</div>
                        <div><span>{{info.deposit_percent}}</span>保证金</div>
                        <div @click="openCommissionPop()"><span>{{info.commission}}</span>{{info.commission_allowance_list.lists&&info.commission_allowance_list.lists.length>0?"佣金/补贴":"佣金"}}<img s src="@/assets/img/rightIcon.png" alt=""></div>
                    </div>
                    <div class="bidMainBtnBox">
                        <div v-if="info.auction_conditions_url" @click="jumpLink(info.auction_conditions_url,3,3)">拍卖条款</div>
                        <div v-else @click="jumpLink(info.biding_instruction_url,3,2)">竞买须知</div>
                        <div @click="jumpLink(info.deposit_instruction_url,3,4)">保证金说明</div>
                        <div @click="showBottomFun()">竞价阶梯</div>
    
                    </div>
    
                </div>
                <div class="subjectContentBox" @click="jumpTopics(info.article_list[0])" v-if="info.article_list.length>0">
                    <div class="subjectImg">
                        <img :src="info.article_list[0].cover" alt="">
                    </div>
                    <div class="subjectTextBox">
                        <div>{{info.article_list[0].title}}</div>
                        <div class="num">{{info.article_list[0].publish_at}}&nbsp;{{info.article_list[0].view_num}}阅读</div>
                    </div>
                </div>
            </div>
    
        </div>
        <div class="onlineAuction" v-if="isShowOnline">
            <div class="auctionView" @click="onlineClick">
                <span class="auctionTitle">{{onlineTitle}}</span>
                <span class="auctionBtn">参拍 <i v-if="onlinePerson">| {{onlinePerson}}次围观</i></span>
            </div>
        </div>
        <div class="listWrap">
            <!-- <div class="listNum">
                <h4 v-if="dataList">
                    本场拍品(共 {{ proTotal }})
                </h4>
                <div class="searchBtn" @click="toSearch">
                    <span class="searchIcon"></span>搜索
                </div>
            </div> -->
            <!-- navItem orderItem active up -->
            <div class="navBar">
                <div ref="lot" @click="lotClick" class="navItem orderItem active up">
                    Lot号
                </div>
                <div ref="gujia" @click="gujiaClick" class="navItem orderItem">
                    {{picAttribute.status==5?"成交价":"估价"}}
                </div>
                <div ref="gaoqing" @click="gaoqingClick" class="navItem">
                    超清大图
                </div>
                <div ref="shangpai" @click="historyClick" class="navItem">
                    上拍历史
                </div>
            </div>
            <div v-if="loadingIf" ref="scrBox">
                <div class="speList">
                    <van-list v-model="loading" :offset='50' :immediate-check="false" :finished="finished" finished-text="" @load="onLoad">
                        <ul>
                            <li v-for="(item, index) in dataList" :key="index">
                                <dl>
                                    <dt @click="underJump(item,index)">
                                        <div class="imgCenter">
                                            <!-- <img src="../../assets/img/avator.jpeg" alt="" /> -->
                                            <img :src="item.coverPic" alt="" />
                                            <div v-if="item.ShowType==1" class="showTypeBox">
                                                <lottie class="iconSty" :options="heartOptions" :height="1" :width="1" />
                                            </div>
                                        </div>
                                        <span class="HiPic" v-if="item.isHD > 0"></span>
                                    </dt>
                                    <dd>
                                        <h3 @click="underJump(item,index)">
                                            <!--5-结拍 4-拍卖中  3-带预展 2-预展中 1-待拍卖-->
                                            <!-- 此处没有加上预展状态 -->
                                            <!-- <span :class="status status1"></span -->
                                            <span :class="[
                                                        'status',
                                                        item.status == 1
                                                            ? 'status1'
                                                            : '',
                                                        item.status == 4
                                                            ? 'status2'
                                                            : '',
                                                        item.status == 5
                                                            ? 'status3'
                                                            : '',
                                                        item.status == 2
                                                            ? 'status4'
                                                            : '',
                                                        item.status == 3
                                                            ? 'status5'
                                                            : '',
                                                    ]"></span> 
                                               <span v-if="item.RestrictTransport==2" class="restrictTransportIcon"></span>
                                                    {{ item.detail.workName }}
                                        </h3>
                                        <div class="speInfo">
                                            <div @click="underJump(item,index)">
                                                <div class="speItem" v-for="(
                                                    item1, index1
                                                ) in item.extraInfo" :key="index1">
                                                    <template v-if="item1.type == 'price'">
                                                        <template v-if="item.status == 5">
                                                            <p :class="[
                                                        'item',
                                                        'icon4'
                                                    ]">
                                                                <template v-if="item1.text=='未提供'">
                                                                    {{item1.label+"："}}{{item1.text}}
                                                                </template>
                                                                <template v-else-if="item1.text=='流拍'">
    
                                                                    {{item1.label+"："}}{{item1.text}}
                                                                </template>
                                                                <template v-else-if="item1.text=='撤拍'">
    
                                                                    {{item1.label+"："}} {{item1.text}}
                                                                </template>
                                                                <template v-else>
                                                                    {{item1.label+"："}}{{ (isLogin&&(item1.needMember==1?(isMem==1):true)  || info.live_info.bid_type==1&&info.live_info.bid_status==2) ? item1.smallText+' '+item1.text : item1.smallText+' '+item1.nonMemberText+''}}
                                                                </template>
    
                                                            </p>
                                                        </template>
                                                        <template v-else>
                                                            <p :class="[
                                                        'item',
                                                        'icon2',
                                                    ]">
    
                                                                {{item1.label+"："}}{{item1.smallText}}&nbsp;{{ item1.text}}
    
                                                            </p>
                                                        </template>
                                                    </template>
                                                    <template v-else-if="item1.type=='gujia'">
                                                        <p :class="[
                                                        'item',
                                                        'icon2',
                                                    ]">
    
                                                            {{item1.label+"："}}{{item1.smallText}}&nbsp;{{ item1.text}}
    
                                                        </p>
                                                    </template>
                                                    <template v-else>
                                                        <p :class="[
                                                        'item',
                                                        'icon' + Number(++index1),
                                                    ]">
                                                            {{item1.type=='start_price'||item1.type=='now_price'?item1.label+"：":""}} {{ item1.text}}{{item1.smallText}}
                                                        </p>
                                                    </template>
    
                                                </div>
                                            </div>
                                            <!-- <span v-if="item.isJoinTuLu == 0 && !from" class="addTulu" @click="gotoApp">加入图录</span> -->
                                        </div>
                                    </dd>
                                </dl>
                            </li>
                        </ul>
                    </van-list>
                </div>
                <div class="noMore" v-if="noMore">
                    <span>我是有底线的</span>
                </div>
            </div>
            <emptyPage v-else></emptyPage>
            <template v-if="!unLoginFlagFun()">
                <template v-if="info.live_info.bid_type==1 ">
                    <div class="fixBot">
                        <template v-if="info.live_info.bid_status==3">
                            <div class="liveBtn" style="margin-left:4%;border-radius: 1rem;width: 30%;float: left;" :style="isMem==1?'width: 90%;':''">
                                <a :href="
                                    'https://m-auction.artron.net/trade/auction/live/' +
                                    info.live_info.special_id+'?cloud_special_id='+info.CloudSpecialId
                                ">直播回放</a>
                            </div>
                            <div v-if="isMem!=1" class="liveBtn" style="margin-right:4%;border-radius: 1rem;width: 60%;float: right;background: #2B2B2C;">
                                <a style="color: #FBCF79;" @click="gotoVip" href="#">成为藏家会员查看成交价</a>
                            </div>
    
                        </template>
                        <template v-else>
                            <div class="bidIcon" @click="jumpOrgan()">
                                <img src="@/assets/img/bid_type_icon2.png" alt="">
                                <span>拍行</span>
                            </div>
                            <div class="bidIcon" @click="contactPopFun()">
                                <img src="@/assets/img/bid_type_icon1.png" alt="">
                                <span>客服</span>
                            </div>
                            <div class="liveBtn" @click="jumpLiveLink('https://m-auction.artron.net/trade/auction/live/' + info.live_info.special_id+'?cloud_special_id='+info.CloudSpecialId)" style="border-radius: 1rem;width: 70%;float: right;">
                                {{info.live_info.bid_status==2?"正在直播":"即将开拍"}}
                            </div>
                        </template>
    
                    </div>
    
                </template>
                <template v-else>
                    <template v-if="
                        info.live_info.have_live > 0 && info.live_info.bid_status != 3
                    ">
                        <div class="fixBot" :class="isVipBtnShow?'vipBtnShow':''">
                            <div class="liveBtn">
                                <a :href="
                                    'https://m-auction.artron.net/live/detail?id=' +
                                    info.live_info.lives[0].live_id +
                                    '&special_id=' +
                                    info.live_info.special_id
                                ">{{info.live_info.bid_status == 1 || info.live_info.bid_status == 2 ? '即将开播' :'进入直播间'}}</a>
                            </div>
    
                        </div>
                    </template>
                    <template v-else-if="info.live_info.have_review > 0">
                        <div class="fixBot" :class="isVipBtnShow?'vipBtnShow':''">
                            <div class="liveBtn">
                                <a :href="
                                    'https://m-auction.artron.net/live/detail?id=' +
                                    info.live_info.lives[0].live_id +
                                    '&special_id=' +
                                    info.live_info.special_id
                                ">直播回放</a>
                            </div>
    
                        </div>
    
                    </template>
                    <template v-else>
                        <div class="fixBot" v-if="info.status==5">
                            <div v-if="isMem!=1" class="liveBtn" style="margin-right:4%;border-radius: 1rem;width: 90%;float: right;background: #2B2B2C;">
                                <a style="color: #FBCF79;" @click="gotoVip" href="#">成为藏家会员查看成交价</a>
                            </div>
                        </div>
    
                        <!-- <div class="footBtnBox">
                        <div v-if="isLogin != 0" class="userMsgBox">
                        <img :src="headerImg" alt="">{{memberStatus==1?'藏家会员已过期':'未开通藏家会员'}}
                    </div>
                    <div class="liveBtn">
    
                        <div v-if="isLogin == 0" @click="gotoLoginFun()">立即登录，查看价格</div>
                        <div v-else @click="gotoVip">成为藏家会员查看成交价</div>
                    </div>
    
                        <div @click.stop="gotoApp()" class="footBtn">
                            <img src="../../assets/img/Frame@2x.png" alt=""> APP内打开
                        </div>
                    </div> -->
                    </template>
                </template>
            </template>
            <!--        <template v-if="zxpUrl">-->
            <!--            <div class="fixBot">-->
            <!--                <div class="liveBtn">-->
            <!--                    <a :href="zxpUrl">立即参拍</a>-->
            <!--                </div>-->
            <!--            </div>-->
            <!--        </template>-->
        </div>
        <DownLoadApp ref="downloadPop"></DownLoadApp>
        <watermark v-if="showWater"></watermark>
        <van-popup round v-model="showCommissionPop" class="auction-detail-info-list" position="bottom" closeable :style="{ height: '50%', width: '100%',padding:'1rem' }">
    
            <div style="margin-top:1rem;width: 100%;font-size: 0.9rem;font-weight: 600;color: #000000;text-align: center;margin-bottom: 1rem;">{{info.commission_list.type==2?'佣金/补贴规则':'佣金规则'}}</div>
            <template v-for="(item,index) in info.commission_list.lists_new" >

           
                <div class="title" v-if="index==0"  :key="'commission_list'+index">
                    <div class="item">{{ item.ratio }}</div>
                    <div class="item" v-if="info.commission_list.type==2">{{ item.subsidy }}</div>
                    <div class="item" :style="info.commission_list.type==2?'flex: 2;':''">{{ item.time_range }}</div>
                </div>
                <div class="row" v-else :key="'commission_list'+index">
                    <div class="item">{{ item.ratio }}</div>
                    <div class="item" v-if="info.commission_list.type==2">{{ item.subsidy }}</div>
                    <div class="item" :style="info.commission_list.type==2?'flex: 2;':''">{{ item.time_range }}</div>
                </div>
            </template>
            <!-- <template v-if="info.commission_allowance_list.lists_new&&info.commission_allowance_list.lists_new.length>0">
                <div style="margin-top:1rem;width: 100%;font-size: 0.9rem;font-weight: 600;color: #000000;text-align: center;margin-bottom: 1rem;">补贴规则</div>
                <template v-for="(item,index) in info.commission_allowance_list.lists_new" >
                <div class="title"  v-if="index==0"  :key="'commission_allowance_list'+index">
                    <div class="item">{{ item.ratio }}</div>
                    <div class="item">{{ item.time_range }}</div>
                </div>
                <div class="row"  v-else :key="'commission_allowance_list'+index">
                    <div class="item">{{ item.ratio }}</div>
                    <div class="item">{{ item.time_range }}</div>
                </div>
                </template>
            </template> -->
    
        </van-popup>
        <van-popup class="bottomPopup" closeable v-model="showBottom" position="bottom" :style="{ height: '60%' }">
            <template v-if="info.bid_range!=''">
    
                <div class="popupTitle">竞价阶梯</div>
                <div class="popup">
                    <van-row class="tabTitle">
                        <van-col span="12">{{info.bid_range.title_left}}</van-col>
                        <van-col span="12">{{info.bid_range.title_right}}</van-col>
                    </van-row>
                    <template v-for="(item,index) in info.bid_range.prices">
                        <van-row class="tabText" :key="'prices'+index">
                            <van-col span="12">{{item.region}}</van-col>
                            <van-col span="12">{{item.step}}</van-col>
                        </van-row>
                    </template>
                </div>
                <div class="popupDest">
                    *此阶梯之作为参考，拍卖会根据现场情况进行调整
                </div>
            </template>
        </van-popup>
        <div class="podWrap">
            <!-- <div class="podReviewBtn" ></div> -->
            <div v-if="havePdf" class="openTool">
    
                <div @click="gotoApp(6,2)">
                    <img src="../../assets/img/dzs_icon.png" alt="">
                    <span>电子书</span>
                </div>
    
            </div>
          
                <template v-if="isLogin">
                    <div class="openTool">
                        <div @click="goLink()">
                            <img style="border-radius:1.5rem;" :src="headerImg" alt="">
                            <span>我的</span>
                            <img v-if="isMem==1" class="toolVipIcon" src="../../assets/img/Frame486@2x.png">
                        </div>
                    </div>
                </template>
                <!-- <template v-else>
                    <div @click="gotoLoginFun()">
                        <img src="../../assets/img/Group 502@2x.png" alt="">
                        <span>未登录</span>
                    </div>
                </template> -->
    
           
            <contact :info="info" :contactPop="contactPop"></contact>
            <!-- <div v-if="canBuy" class="podBuyBtn" @click="gotoApp"></div> -->
        </div>
        <div class="unLoginBox" v-show="unLoginFlagFun()&&!showWater"  >
            <div style="font-size: 0.6rem;color: #6B6C6C;">完成登录，解锁更多内容</div>
            <template  v-if="isAndroidShow&&isWx">
                 <wx-open-launch-app
                    id="login-btn"
                    style="width: 100%; display: block"
                    :extinfo="JSON.stringify({url: 'special',param: $route.params.specialCode})"
                    appid="wx7f6c9c7fe8734e8f"
                    >
                    <script type="text/wxtag-template">
                        <style>
                        .unLoginBtn {
                                width: 80%;
                                height: 2.7rem;
                                line-height: 2.7rem;
                                background: #000000;
                                margin: 1.2rem auto;
                                color: #fff;
                                border-radius: 1.2rem;
                                font-size: 1rem;
                                text-align: center;
                            }
                        </style>
                        <div class="unLoginBtn">立即登录</div>
                    </script>
                    </wx-open-launch-app>
                </template>
                <template  v-else>
                     <div  @click="gotoAppDown()" class="unLoginBtn">立即登录</div>
                </template>
            <img @click="gotoMember()" src="../../assets/img/unLoginIcon.png" alt="">
            <div style="font-size: 0.55rem;color: #949596;">成为雅昌藏家会员，查看成交信息，畅览高清大图</div>
    
        </div>
        <div class="custom-container">

        </div>
    
    </div>
    </template>
    
    <script>
    import {
        mapActions,
        mapGetters
    } from "vuex";
    import {
        audience,
        getMemType,
        setBidClick
    } from "@/api/auction";
    import emptyPage from "@/components/empty/emptyPage";
    import {
        alertInfo,
        getWXConfig
    } from "@/assets/js/weixinShare";
    import panel from "@/views/preview/component/panel.vue";
    import DownLoadApp from "@/components/common/downloadApp";
    import contact from "@/components/contact";
    import {
        isWeixin,
    } from "@/api/auction/isWeixin";
    import {
        indexFocus
    } from "@/api/index";
    import watermark from "@/components/common/watermark";
    import {
        Toast
    } from "vant";
    import {
        scMdFunc,
        gotoLogin
    } from "@/assets/js/scData";
    import {
        getApp
    } from "@/api/request";
    import lottie from '@/components/common/lottie'
    const liveIcon = require('../../assets/img/data.json')
    var isRefresh = false
    const liveIcon2 = require('../../assets/img/live.json')
    const liveIcon3 = require('../../assets/img/live_icon_2.json')
    export default {
        name: "search_special",
        data() {
            return {
                isMem: 0,
                waterLink: "",
                showCommissionPop: false,
                heartOptions: {
                    animationData: liveIcon,
                    loop: true,
                    autoplay: true,
                },
                heartOptions2: {
                    animationData: liveIcon2,
                    loop: true,
                    autoplay: true,
                },
                heartOptions3: {
                    animationData: liveIcon3,
                    loop: true,
                    autoplay: true,
                },
                showWater: false,
                picAttribute: {
                    status: 0
                },
                contactPop: false,
                noJump: true,
                from: this.$route.query.from,
                loading: false,
                finished: false,
                showBottom: false,
                loadingIf: true,
                noMore: false,
                dataList: [],
                sortNum: 0, //排序类名
                t: 0,
                uid: 0,
                headerImg: '',
                extinfo: '',
                info: {
                    article_list: [],
                    commission_list: {
                        lists_new:[]
                    },
                    commission_allowance_list: {
                        lists_new:[]
                    },
                    bid_range: "",
                    live_info: {
                        have_live: 0,
                        have_review: 0,
                        label_list: [],
                        live_status: 0,
                        lives: [],
                        special_id: 0,
                        status_name: ""
                    }
                }, //总的数据
                detailInfopic: null, //拍卖会名称
                detailInfoName: "", //拍卖会名称
                extraInfo: [], //标题详情三个
                appLink: "/2/4/" + this.$route.params.specialCode,
                isWx: true,
                scFlag: true,
                scData: {
                    auction_specia_performance_id_pk: '',
                    auction_specia_performance_id: '',
                    the_auction_id_pk: '',
                    the_auction_id: '',
                    auction_company_id: '',
                    auction_company_code: '',
                    auction_state: '',
                    auction_type: '',
                },
                param: {
                    isAppraise: 0,
                    isBigPic: 0,
                    keyword: "",
                    orderby: 1, //估价和lot
                    page: 1,
                    specialCode: "",
                    show: 0,
                }, //参数
                keyWordls: {
                    isAppraise: 0,
                    isBigPic: 0,
                    keyword: "",
                    orderby: 1, //估价和lot
                    page: 1,
                    specialCode: "",
                    only_meta: 1,
                },
                isLogin: 0,
                beforeLink: '',
                proTotal: '',
                canBuy: '',
                havePdf: '',
                onlineTitle: '',
                onlineUrl: '',
                isShowOnline: false,
                isAndroidShow: true,
                loginFlag:false,
                sessionCode: '',
                sessionName: '',
                zxpUrl: '',
                onlinePerson: 0,
                isVipBtnShow: false,
                memberStatus: 0,
                scrollTop: 0,
                scrollFalg: 0,
                scrollJumpFalg: true,
                haveResultPrice: 0,
                version: 0,
                dataJSON: null
            };
        },
        created() {
            // this.getApp()
            // this.t = Date.now()
            // if (this.$route.query.from && this.from == 1) {
            //     this.noJump = false;
            // }
            // if (
            //     (this.$route.query.from && this.$route.query.from == 1) ||
            //     (this.$route.query.from && this.$route.query.from == 2)
            // ) {
            //     this.showWater = true;
            //     this.waterLink = "?from=" + this.$route.query.from;
            // }
            // // 接口调用
            // this.getMemTypeFun();
            // this.getAudiencepa();
            // this.sortNum = 0;
            let that = this;
            that.extinfo = JSON.stringify({
                url: "special",
                param: that.$route.params.specialCode
            })
        },
        computed: {
            ...mapGetters({
                getIsLoadIng: "pageSpecial/getIsLoadIng",
                getData: "pageSpecial/getData",
            }),
        },
        methods: {
            ...mapActions({
                getAudience: "pageSpecial/getAudience",
            }),
            gotoMember(){
                window.location.href = 'https://m-auction.artron.net/tulu/wap/share/vipmember';
            },
            goLink(){
                window.location.href = 'https://member.artron.net/memCenter/';
            },
            openCommissionPop() {
                this.showCommissionPop = true
            },
            onLineSpecial(){
                // if(str.indexOf(substring) !== -1){
                //     return false
                // }else{
                //     return true
                // }
                
            },
            jumpLiveLink(e) {
                scMdFunc('allClick', {
                    cur_page: '5',
                    cur_moudle: '5-7',
                    cur_button: '5-7-' + (this.info.live_info.bid_status == 2 ? "4" : "3"),
                    ...this.scData
                })
                window.location.href = e
            },
            contactPopFun() {
    
                this.contactPop = true
                scMdFunc('allClick', {
                    cur_page: '5',
                    cur_moudle: '5-7',
                    cur_button: '5-7-2',
                    ...this.scData
                })
            },
            jumpOrgan() {
                let companyId = "";
                scMdFunc('allClick', {
                    cur_page: '5',
                    cur_moudle: '5-7',
                    cur_button: '5-7-1',
                    ...this.scData
                })
                this.extraInfo.forEach(function (i) {
                    if (i.type == "company") {
                        companyId = i.organCode;
                    }
                });
                this.$router.push({
                    path: "/organ/" + companyId,
                    query: {
                        // from:this.showWater ? this.$route.query.from :''
                    },
                });
            },
            jumpTopics(e) {
                if(e.article_type==1){
                    this.$router.push({
                        path: "/topics/" + e.article_id
                    })
                }
                if(e.article_type==2){
                    window.location.href = 'https://tulu.artron.net/wap/share/observe?id='+this.$route.params.specialCode
                }
              
            },
            jumpLink(e, m = '', b = '') {
                if (m != '') {
                    scMdFunc('allClick', {
                        cur_page: '5',
                        cur_moudle: '5-' + m,
                        cur_button: '5-' + m + '-' + b,
                        ...this.scData
                    })
                }
                window.location.href = e;
            },
            unLoginFlagFun() {
            
                if (!this.isLogin&&this.dataList.length>0) {
                    if (this.dataList.length < 2) {
                            return false
                        } else {
                            return true
                        }
                 
                    // if (this.info.live_info.bid_type == 2 || this.info.live_info.bid_type == 1) {
                    //     if (this.dataList.length < 2) {
                    //         return false
                    //     } else if (this.info.live_info.bid_status == 3) {
                    //         return true
                    //     } else {
                    //         return false
                    //     }
                    // } else {
                    //     if (this.dataList.length < 2) {
                    //         return false
                    //     } else {
                    //         return true
                    //     }
                    // }
    
                } else {
                    return false
                }
                return false
            },
            gotoLoginFun() {
                function isGreaterThan9() {
                    var getOsv = function () {
                        var reg = /OS ((\d+_?){2,3})\s/;
                        if (navigator.userAgent.match(/iPad/i) || navigator.platform.match(/iPad/i) || navigator.userAgent.match(/iP(hone|od)/i) || navigator.platform.match(/iP(hone|od)/i)) {
                            var osv = reg.exec(navigator.userAgent);
                            if (osv.length > 0) {
                                return osv[0].replace('OS', '').replace('os', '').replace(/\s+/g, '').replace(/_/g, '.');
                            }
                        }
                        return '';
                    };
                    var osv = getOsv();
                    var osvArr = osv.split('.');
                    if (osvArr && osvArr.length > 0) {
                        if (parseInt(osvArr[0]) >= 9) {
                            return true;
                        }
                    }
                    return false;
                }
                if (isGreaterThan9()) {
                            //判断是否为ios9以上的版本,跟其他判断一样navigator.userAgent判断,ios会有带版本号
                            this.gotoApp()
                } else {
                    gotoLogin()
                }
              
            },
            followFun(e) {
                let parmas = {
                    special_type: 1,
                    action: e.isFocus == 0 ? 1 : 2,
                    code: e.specialCode,
                }
                scMdFunc('allClick', {
                    cur_page: '5',
                    cur_moudle: '5-1',
                    cur_button: '5-1-2',
                    ...this.scData
                })
                if (!e.isLogin) { //未登录
                    gotoLogin()
                } else {
                    indexFocus(parmas).then((res) => {
                        if (res.code == 0) {
                            if (e.isFocus == 0) {
                                this.$toast('关注成功')
                            }
    
                            e.isFocus = e.isFocus == 0 ? 1 : 0;
    
                        }
                    })
                }
    
            },
            getApp() {
                getApp('/source').then((res) => {
                    if (res.data.isApp) {
                        this.version = res.data.version
                    }
                })
            },
            getMemTypeFun() {
                getMemType().then((res) => {
                    if (res.code == 0) {
                        this.isMem = res.data.isMember;
                        this.memberStatus = res.data.memberStatus;
                        this.showVipBtn();
                    }
                })
            },
            getCookie: function (name) {
                var arr;
                var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
                if (document.cookie.match(reg)) {
                    arr = document.cookie.match(reg);
                    return arr[2];
                } else {
                    return null;
                }
            },
            showBottomFun() {
                this.showBottom = true
                scMdFunc('allClick', {
                    cur_page: '5',
                    cur_moudle: '5-3',
                    cur_button: '5',
                    ...this.scData
                })
    
            },
            gotoAppDown(m = '', b = '') {
                if (m != '') {
                    scMdFunc('allClick', {
                        cur_page: '5',
                        cur_moudle: '5-' + m,
                        cur_button: '5-' + m + '-' + b,
                        ...this.scData
                    })
                }
    
                if (this.$route.query.from == 1 && this.$route.query.from) {
                    return false
                } else {
                    this.$refs.downloadPop.gotoAppDownload(this.appLink, encodeURIComponent(window.location.href),true);
                }
            },
            gotoApp(m = '', b = '') {
                if (m != '') {
                    scMdFunc('allClick', {
                        cur_page: '5',
                        cur_moudle: '5-' + m,
                        cur_button: '5-' + m + '-' + b,
                        ...this.scData
                    })
                }
    
                if (this.$route.query.from == 1 && this.$route.query.from) {
                    return false
                } else {
                    this.$refs.downloadPop.gotoAppDownload(this.appLink, 0);
                }
            },
            filteData() {
                // 微信分享功能+title
                let dome = this.$store.state["pageSpecial"]["data"];
    
                document.title = dome.shareMessage ? dome.shareMessage.title : "";
                // let head = document.getElementsByTagName("head");
                // if (!document.querySelector("meta[name=description]")) {
                //     let meta = document.createElement("meta");
                //     meta.name = "description";
                //     meta.content = dome.meta ? dome.meta.description : "";
                //     head[0].appendChild(meta);
                // } else {
                //     document
                //         .querySelector("meta[name=description]")
                //         .setAttribute(
                //             "content",
                //             dome.meta ? dome.meta.description : ""
                //         );
                // }
                window.AFedWxShareData = {
                    title: dome.shareMessage ? dome.shareMessage.title : "",
                    imgUrl: dome.shareMessage.pic ||
                        "https://pubunder.artron.net/pubimgs/m/wxImgAuc.png",
                    desc: dome.shareMessage.desc || "",
                    link: window.location.href,
                };
                getWXConfig(window.AFedWxShareData);
                // console.log("this.$state",this.$store.state["pageIndex"]);
                // this.bannerList = this.$store.state["pageIndex"]["data"].slicepics
                // this.swiperNews = this.$store.state["pageIndex"]["data"].slicenews
                // this.buttons = this.$store.state["pageIndex"]["data"].buttons;
                // this.topSpeciel = this.$store.state["pageIndex"]["data"].speical;
            },
            // 顶部返回按钮
            goBack() {
                this.$router.back()
                // if (document.referrer) {
                //     window.location.href = document.referrer
                // } else if (window.history.state) {
                //     this.$router.back()
                // } else if (this.$route.query.fromlink) {
                //     window.location.href = decodeURIComponent(this.$route.query.fromlink)
                // } else {
                //     this.$router.push({
                //         path: "/"
                //     });
                // }
            },
            //头部跳转详情页面
            toSpecialDetail() {
                scMdFunc('allClick', {
                    cur_page: '5',
                    cur_moudle: '5-2',
                    cur_button: '5-2-1',
                    ...this.scData
                })
                if (this.$route.query.from == 1 && this.$route.query.from) {
                    return false
                } else {
                    this.$router.push({
                        name: 'search_special_detail',
                        query: {
                            specialCode: this.$route.params.specialCode,
                            from: this.$route.query.from
                        }
                    });
                }
            },
            alertInfo() {
                scMdFunc('allClick', {
                    cur_page: '5',
                    cur_moudle: '5-1',
                    cur_button: '5-1-3',
                    ...this.scData
                })
                alertInfo("分享时请使用浏览器自身的分享工具");
            },
            // 跳转搜索页面
            toSearch() {
                scMdFunc('allClick', {
                    cur_page: '5',
                    cur_moudle: '5-1',
                    cur_button: '5-1-1',
                    ...this.scData
                })
                // this.$router.push({ path: "/special_search_result",query:{specialCode:$route.query.specialCode} });
                if (this.$route.query.from == 1 && this.$route.query.from) {
                    return false
                } else {
                    this.$router.push({
                        name: "special_search_result",
                        query: {
                            specialCode: this.$route.params.specialCode,
                            from: this.$route.query.from
                        }
                    });
                }
            },
            // 跳转底层页面
            underJump(item, i) {
                let bridge = window.WebViewJavascriptBridge;
                let isTuluApp = (/(SwiftTuLu|ArtronTulu|HarmonyOSTulu)/g).test(window.navigator.userAgent)
                scMdFunc('allClick', {
                    cur_page: '5',
                    cur_moudle: '5-5',
                    cur_button: '5-5-' + (Number(i) + 1),
                    auction_items_id: item.artCode,
                    lot_category1_id: item.classCodeOne,
                    lot_category2_id: item.classCodeTwo,
                    auction_specia_performance_id_pk: item.special_id,
                    auction_specia_performance_id: item.special_code,
                    the_auction_id_pk: item.session_id,
                    the_auction_id: item.session_code,
                    auction_company_id: item.organ_id,
                    auction_company_code: item.organ_code,
                    auction_state: item.status == 1 ? '待拍卖' : item.status == 2 ? '预展中' : item.status == 3 ? '待预展' : item.status == 4 ? '拍卖中' : item.status == 5 ? '已结拍' : '',
                    auction_type: item.BidAuctionType,
                })
                if (item.ShowType == 1) {
                    window.location.href = item.ShowLink;
                } else {
                    if (isTuluApp) {
                        bridge.callHandler('appArtDetail', {
                            artCode: item.artCode,
                            from_page: '5',
                            from_module: '5-5',
                            from_button: '5-5-' + (Number(i) + 1),
                            from_page_pk: item.session_id,
                        }, function () {})
                        // if (isGreaterThan9()) {
                        //     //判断是否为ios9以上的版本,跟其他判断一样navigator.userAgent判断,ios会有带版本号
                        //     bridge.callHandler('appArtDetail', {
                        //         artCode: item.artCode,
                        //     }, function () {})
                        // } else {
                        //     this.$refs.downloadPop.gotoAppDownload('/2/5/' + item.artCode, 0);
                        // }
    
                    } else {
                        if (this.$route.query.from == 1 && this.$route.query.from) {
                                let inspect=item.pc_extra_info.filter(items =>   items && typeof items === 'object' &&  'type' in items &&  items.type === 'art_inspect_id'    );
                            if(inspect.length>0){
                                window.location.href = "https://m-auction.artron.net/trade/auction/detail/" + item.artCode + '?from=' + this.$route.query.from + '&organ_id=' + this.$route.query.organ_id + '&inspect_id=' + inspect[0].text
                             }
                          return false
                        } else {
                            window.location.href = "https://m-auction.artron.net/trade/auction/detail/" + item.artCode + '?scId=' + this.info.specialCode + '&scFrom=5-5-' + (Number(i) + 1) + '-' + this.info.specialCode + '-' + item.artCode;
                            // this.$router.push({
                            //     path: "/productdetail/" + item.artCode + this.waterLink,
                            // });
                        }
                    }
                }
    
            },
            // lot号
            lotClick() {
                this.$refs.lot.classList.add("active");
                this.loading = true;
                scMdFunc('allClick', {
                    cur_page: '5',
                    cur_moudle: '5-4',
                    cur_button: '5-4-1',
                    ...this.scData
                })
    
                if (this.$refs.lot.className.includes("down")) {
                    this.$refs.lot.classList.add("up");
                    this.$refs.lot.classList.remove("down");
                    // lot号升序1
                    this.param.orderby = 1;
                    this.param.isAppraise = 0;
                    this.param.isBigPic = 0;
                    this.dataList = [];
                    this.param.page = 1;
                    this.getAudiencepa();
                } else if (this.$refs.lot.className.includes("up")) {
                    this.$refs.lot.classList.add("down");
                    this.$refs.lot.classList.remove("up");
                    // lot号降序 2
                    this.param.orderby = 2;
                    this.param.isAppraise = 0;
                    this.param.isBigPic = 0;
                    this.dataList = [];
                    this.param.page = 1;
                    this.getAudiencepa();
                } else {
                    this.$refs.lot.classList.add("up");
                    // lot号升序1
                    this.param.orderby = 1;
                    this.param.isAppraise = 0;
                    this.param.isBigPic = 0;
                    this.dataList = [];
                    this.param.page = 1;
                    this.getAudiencepa();
                }
                // 去除其他的样式
                this.$refs.gujia.classList.remove("active");
                this.$refs.gujia.classList.remove("up");
                this.$refs.gujia.classList.remove("down");
                this.$refs.gaoqing.classList.remove("active");
                this.$refs.shangpai.classList.remove("active");
                // 改变参数
    
                // this.getAudiencepa()
            },
            // 估价
            gujiaClick() {
                this.$refs.gujia.classList.add("active");
                this.loading = true;
                scMdFunc('allClick', {
                    cur_page: '5',
                    cur_moudle: '5-4',
                    cur_button: '5-4-' + (this.picAttribute.status == 5 ? "3" : "2"),
                    ...this.scData
                })
                if (this.$refs.gujia.className.includes("down")) {
                    this.$refs.gujia.classList.add("up");
                    this.$refs.gujia.classList.remove("down");
                    // lot升序4
                    this.param.orderby = 4;
                    this.param.isAppraise = 0;
                    this.param.isBigPic = 0;
                    this.dataList = [];
                    this.param.page = 1;
                    this.getAudiencepa();
                } else if (this.$refs.gujia.className.includes("up")) {
                    this.$refs.gujia.classList.add("down");
                    this.$refs.gujia.classList.remove("up");
                    // lot降序 3
                    this.param.orderby = 3;
                    this.param.isAppraise = 0;
                    this.param.isBigPic = 0;
                    this.dataList = [];
                    this.param.page = 1;
                    this.getAudiencepa();
                } else {
                    this.$refs.gujia.classList.add("up");
                    // lot号升序4
                    this.param.orderby = 4;
                    this.param.isAppraise = 0;
                    this.param.isBigPic = 0;
                    this.dataList = [];
                    this.param.page = 1;
                    this.getAudiencepa();
                }
                // 去除其他的样式
                this.$refs.lot.classList.remove("active");
                this.$refs.lot.classList.remove("up");
                this.$refs.lot.classList.remove("down");
                this.$refs.gaoqing.classList.remove("active");
                this.$refs.shangpai.classList.remove("active");
            },
            gaoqingClick() {
                this.$refs.gaoqing.classList.add("active");
                scMdFunc('allClick', {
                    cur_page: '5',
                    cur_moudle: '5-4',
                    cur_button: '5-4-4',
                    ...this.scData
                })
                // 去除其他的样式
                this.$refs.lot.classList.remove("active");
                this.$refs.lot.classList.remove("up");
                this.$refs.lot.classList.remove("down");
                this.$refs.gujia.classList.remove("active");
                this.$refs.gujia.classList.remove("up");
                this.$refs.gujia.classList.remove("down");
                this.$refs.shangpai.classList.remove("active");
    
                //高清大图
                this.param.orderby = 1;
                this.param.isAppraise = 0;
                this.param.isBigPic = 1;
                this.dataList = [];
                this.param.page = 1;
                this.getAudiencepa();
            },
            historyClick() {
                this.$refs.shangpai.classList.add("active");
    
                // 去除其他的样式
                this.$refs.lot.classList.remove("active");
                this.$refs.lot.classList.remove("up");
                this.$refs.lot.classList.remove("down");
                this.$refs.gujia.classList.remove("active");
                this.$refs.gujia.classList.remove("up");
                this.$refs.gujia.classList.remove("down");
                this.$refs.gaoqing.classList.remove("active");
    
                // 上牌历史
                this.param.orderby = 1;
                this.param.isAppraise = 1;
                this.param.isBigPic = 0;
                this.dataList = [];
                this.param.page = 1;
                this.getAudiencepa();
            },
            // 排序功能
    
            // 调取接口
            getAudiencepa() {
                let that = this
                this.noMore = false;
                this.loadingIf = true;
                this.param.specialCode = this.$route.params.specialCode;
                if (this.$route.query.from == 1) {
                    this.param.show = 1;
                }
                audience(this.param).then((res) => {
                    if (res.code == 0) {
                        console.log(res.data)
                        this.info = res.data;
                        if(this.info.current_bid_special.name){
                            this.$dialog.confirm({
                                title: '提示',
                                getContainer: ".custom-container",
                                message: this.info.current_bid_special.name,
                                confirmButtonText: '前往观看',
                                cancelButtonText: '留下'
                                })
                                .then(() => {
                                window.location.href = 'https://m-auction.artron.net/special/'+this.info.current_bid_special.specialCode;
                                })
                        }
                        this.isLogin = this.info.isLogin
                        this.detailInfopic = res.data.picUrl;
                        this.detailInfoName = res.data.name;
                        this.extraInfo = res.data.extraInfo;
    
                        let {
                            canBuy,
                            havePdf
                        } = res.data.pod;
                        this.picAttribute = res.data.picAttribute
                        this.canBuy = canBuy;
                        this.havePdf = havePdf;
                        this.zxpUrl = res.data.zxpUrl
                        this.scData = {
                            auction_specia_performance_id_pk: res.data.special_id,
                            auction_specia_performance_id: res.data.specialCode,
                            the_auction_id_pk: res.data.session_id,
                            the_auction_id: res.data.session_code,
                            auction_company_id: res.data.organ_id,
                            auction_company_code: res.data.organ_code,
                            auction_state: res.data.live_info.bid_status == 1 ? '待拍卖' : res.data.live_info.bid_status == 2 ? '预展中' : res.data.live_info.bid_status == 3 ? '待预展' : res.data.live_info.bid_status == 4 ? '拍卖中' : res.data.live_info.bid_status == 5 ? '已结拍' : '',
                            auction_type: res.data.live_info.bid_type
                        }
    
                        res.data.detailExtraInfo.forEach((item) => {
                            if (item.name == 'total') {
                                that.proTotal = item.text
                            }
                            if (item.type == 'session') {
                                that.sessionCode = item.sessionCode
                                // that.getOnLineAuction();
                                that.sessionName = item.text
                            }
                        })
                        if (!res.data.dataList && res.data.morePage != 1) {
                            this.loading = false;
                            this.finished = true;
                        }
                        if (res.data.dataList) {
                            this.dataList = this.dataList.concat(res.data.dataList);
                            if (this.dataList.length == 0) {
                                this.loadingIf = false;
                            }
                            this.loading = false;
                            this.param.page++;
                            if (res.data.morePage == 0) {
                                this.finished = true;
                                this.noMore = true;
                            }
                        }
                        if (res.data.catalog_info_new && res.data.catalog_info_new.length) {
                            let catalog = res.data.catalog_info_new[0];
                            this.isShowOnline = true;
                            this.onlineTitle = catalog.title;
                            this.onlineUrl = catalog.link;
                            this.onlinePerson = res.data.bid_click_num;
                        }
                        this.haveResultPrice = res.data.have_result_price;
    
                        this.showVipBtn();
    
                        let scFromList = ['0', '0', '0', '0', '0'];
                        if (this.scFlag) {
                            if (this.$route.query.scFrom && this.$route.query.scFrom.split("-").length == 5) {
                                scFromList = this.$route.query.scFrom.split("-")
                                scMdFunc('allPageView', {
                                    from_page: scFromList[0],
                                    from_module: scFromList[0] + '-' + scFromList[1],
                                    from_button: scFromList[0] + '-' + scFromList[1] + '-' + scFromList[2],
                                    from_page_pk: this.$route.query.scId || '',
                                    cur_page: '5',
                                    auction_specia_performance_id: this.info.specialCode,
                                    auction_specia_performance_id_pk: this.info.special_id,
                                    the_auction_id_pk: this.info.session_id,
                                    the_auction_id: this.info.session_code,
                                    auction_company_id: this.info.organ_id,
                                    auction_company_code: this.info.organ_code,
                                    auction_state: this.info.live_info.bid_status == 1 ? '待拍卖' : this.info.live_info.bid_status == 2 ? '预展中' : this.info.live_info.bid_status == 3 ? '待预展' : this.info.live_info.bid_status == 4 ? '拍卖中' : this.info.live_info.bid_status == 5 ? '已结拍' : '',
                                    auction_type: this.info.live_info.bid_type,
                                    magnification: Math.floor(Math.random() * (13 - 7 + 1)) + 7,
                                })
                            } else {
                                scMdFunc('allPageView', {
                                    cur_page: '5',
                                    auction_specia_performance_id_pk: this.info.special_id,
                                    auction_specia_performance_id: this.info.specialCode,
                                    the_auction_id_pk: this.info.session_id,
                                    the_auction_id: this.info.session_code,
                                    auction_company_id: this.info.organ_id,
                                    auction_company_code: this.info.organ_code,
                                    auction_state: this.info.live_info.bid_status == 1 ? '待拍卖' : this.info.live_info.bid_status == 2 ? '预展中' : this.info.live_info.bid_status == 3 ? '待预展' : this.info.live_info.bid_status == 4 ? '拍卖中' : this.info.live_info.bid_status == 5 ? '已结拍' : '',
                                    auction_type: this.info.live_info.bid_type,
                                    magnification: Math.floor(Math.random() * (13 - 7 + 1)) + 7,
                                })
                            }
    
                            this.scFlag = false
                        }
    
                        // let companyName = "";
                        // let companyId = "";
                        // this.extraInfo.forEach(function (i) {
                        //     if (i.type == "company") {
                        //         companyId = i.organCode;
                        //         companyName = i.text;
                        //     }
                        // });
    
                        // window._dgt.push([
                        //     "trackEvent",
                        //     "ahspecial",
                        //     [
                        //         "m_click_ahspecial",
                        //         "d_uid",
                        //         "d_specialId",
                        //         "ea_auction_company",
                        //         "ea_theID",
                        //         "ea_name",
                        //         "ea_companyId",
                        //     ],
                        //     [
                        //         "1",
                        //         this.getCookie("_at_pt_0_"),
                        //         this.$route.params.specialCode,
                        //         companyName,
                        //         this.$route.params.specialCode,
                        //         this.detailInfoName,
                        //         companyId,
                        //     ],
                        // ]);
                    } else {
                        Toast({
                            message: '该内容不存在～',
                            duration: 2000,
                            onClose: function () {
                                that.$router.push({
                                    path: '/',
                                    query: {
                                        from: that.$route.query.from
                                    }
                                })
                            }
                        })
                    }
                });
            },
            onLoad() {
                if (this.param.page >= 2) {
                    this.getAudiencepa();
                }
            },
            getPodData() {
                audience({
                    specialCode: this.$route.params.specialCode
                }).then(res => {
                    let {
                        canBuy,
                        havePdf
                    } = res.data.pod;
                    this.canBuy = canBuy;
                    this.havePdf = havePdf;
                })
            },
            getOnLineAuction() {
                // let params = {
                //     code: this.sessionCode,
                //     specialCode: this.$route.params.specialCode,
                // }
                // onlineAuction(params).then((res) => {
                //     let data = res.data;
                //     if (data.catalog && data.catalog.length) {
                //         let catalog = data.catalog[0];
                //         this.isShowOnline = true;
                //         this.onlineTitle = catalog.title;
                //         this.onlineUrl = catalog.link;
                //         this.onlinePerson=123;
                //     }
                // })
            },
            showVipBtn() {
                if (this.picAttribute.status == 5 && this.haveResultPrice && (!(this.isMem == 1 && this.memberStatus == 2))) {
                    this.isVipBtnShow = true;
                } else {
                    this.isVipBtnShow = false;
                }
            },
            gotoVip() {
                let bridge = window.WebViewJavascriptBridge;
                let isTuluApp = (/(SwiftTuLu|ArtronTulu|HarmonyOSTulu)/g).test(window.navigator.userAgent)
                let isToutiaoApp = (/(SwiftToutiao|ArtronToutiao|ArtExpress)/g).test(window.navigator.userAgent)
                if (this.isLogin == 0) {
                    gotoLogin()
                } else {
                    if (!(this.isMem == 1 && this.memberStatus == 2)) {
                        if (bridge && isTuluApp || bridge && isToutiaoApp) {
                            if (isToutiaoApp) {
                                if (this.version >= 464000) {
                                    bridge.callHandler('appGotoRightsMembers', {
                                        index: 0,
                                        source_page: '拍卖专场详情页',
                                        source_module: '成为藏家会员查看成交价',
                                    }, function () {})
                                } else {
                                    bridge.callHandler('appGotoRightsMembers', {
                                        index: 0
                                    }, function () {})
                                }
                            } else {
                                if (this.version >= 1061203) {
                                    bridge.callHandler('appMemberPay', {
                                        source_page: '拍卖专场详情页',
                                        source_module: '成为藏家会员查看成交价'
                                    }, function () {})
                                } else {
                                    bridge.callHandler('appMemberPay', {}, function () {})
                                }
                            }
                        } else {
                            window.location.href = 'http://tulu.artron.net/wap/share/member' + "?from=" + encodeURIComponent(location.href);
                        }
                        // window.location.href='https://member.artronvip.com/wap/share/member?source_page=6&sourceReferer='+encodeURIComponent(window.location.href);
                    }
                }
    
            },
            formatZero: function (num) {
                if (num.length < 9) {
                    num = (Array(10 - num.length).join(0) + num);
                    return num;
                } else {
                    return num;
                }
            },
            onlineClick() {
                let params = {
                    specialCode: this.$route.params.specialCode,
                }
                scMdFunc('allClick', {
                    cur_page: '5',
                    cur_moudle: '5-8',
                    cur_button: '5-8-1',
                    ...this.scData
                })
                setBidClick(params).then(res => {
                    if (res.code == 0) {
                        // this.onlinePerson = res.data.bid_click_num;
                    }
                });
                setTimeout(() => {
                    window.location.href = this.onlineUrl;
                }, 500)
    
            },
            handleScroll(e) {
                let that = this;
                //获取元素高度  this.$refs.init.offsetHeight
                if (that.$route.name == 'search_special') {
                    that.scrollTop = e.target.scrollTop
                    // console.log('that.scrollTop', that.scrollTop);
                    // console.log('that.scrollFalg', that.scrollFalg);
                    // console.log('that.scrollJumpFalg', that.scrollJumpFalg);
    
                }
    
            }
        },
        beforeRouteEnter(to, from, next) {
            if (from.name != "productdetail") {
                isRefresh = true
            } else {
                isRefresh = false
            }
            next()
        },
        activated() {
            // // 该路由组件激活时，记录滚动位置
            // window.addEventListener('scroll', this.handleScroll, true)
            let that = this;
    
            // console.log('that.scrollTop', that.scrollTop);
            // console.log('that.scrollFalg', that.scrollFalg);
            // console.log('that.scrollJumpFalg', that.scrollJumpFalg);
    
            if (isRefresh) {
                this.contactPop = false
                this.$refs.lot.classList.add("active");
                this.loading = true;
                this.$refs.lot.classList.add("up");
                this.$refs.lot.classList.remove("down");
                // lot号升序1
                this.param.orderby = 1;
                this.param.isAppraise = 0;
                this.param.isBigPic = 0;
                this.dataList = [];
                this.param.page = 1;
    
                // 去除其他的样式
                this.$refs.gujia.classList.remove("active");
                this.$refs.gujia.classList.remove("up");
                this.$refs.gujia.classList.remove("down");
                this.$refs.gaoqing.classList.remove("active");
                this.$refs.shangpai.classList.remove("active");
                this.getApp()
                this.t = Date.now()
                if (this.$route.query.from && this.from == 1) {
                    this.noJump = false;
                }
                if (
                    (this.$route.query.from && this.$route.query.from == 1) ||
                    (this.$route.query.from && this.$route.query.from == 2)
                ) {
                    this.showWater = true;
                    this.waterLink = "?from=" + this.$route.query.from;
                }
                // 接口调用
                this.getMemTypeFun();
                this.getAudiencepa();
                this.sortNum = 0;
               
                this.uid = this.getCookie('_at_pt_0_') && this.getCookie('_at_pt_0_') > 0 ? this.formatZero(this.getCookie('_at_pt_0_')) : 0;
                this.headerImg = this.getCookie('_at_pt_0_') && this.getCookie('_at_pt_0_') > 0 ? 'https://img12' + '.artimg.net/passport/avatar/' + this.uid.substring(0, 3) + '/' + this.uid.substring(3, 6) + '/' + this.uid.substring(6, 9) + '/150_150.png?t=' + new Date().getTime() : '';
                var isTuluApp = (/(SwiftTuLu|ArtronTulu|HarmonyOSTulu)/g).test(window.navigator.userAgent)
                var isToutiaoApp = (/(SwiftToutiao|ArtronToutiao|ArtExpress)/g).test(window.navigator.userAgent)
                if (isTuluApp || isToutiaoApp) {
                    this.noJump = false
                }
                // this.getPodData();
                if (!this.getIsLoadIng) {
                    this.keyWordls.specialCode = this.$route.params.specialCode;
                    if (this.$route.query.from && this.$route.query.from == 1) {
                        this.keyWordls.show = 1;
                    }
                    this.getAudience([
                        this.keyWordls,
                        () => {
                            this.filteData();
                        },
                    ]);
                } else {
                    this.filteData();
                }
    
            } else {
                if (that.scrollTop <= that.scrollFalg && that.scrollJumpFalg) {
                    setTimeout(() => {
                        that.scrollJumpFalg = false;
                        that.$refs.scrollRef.scrollTo(0, that.scrollFalg);
                    }, 10)
    
                }
            }
            // console.log(that.isAndroidShow);
            // console.log(that.isWx);
            // console.log("-----------------ready----------------------------------1111111111111");
            this.$nextTick(() => { 
            if(that.isAndroidShow&&that.isWx){
                    setTimeout(() => {
                        // console.log("-----------------ready----------------------------------222222222");
                            var btn = document.getElementById("login-btn");
                            btn.addEventListener("ready", (e) => {
                                // 在此处可设置粘贴板内数据，数据是传递给 app 的参数进，
                                // console.log("-----------------ready----------------------------------");
                                // alert(2222)
                                that.loginFlag=true;
                            });
                            btn.addEventListener("launch", (e) => {
                                // 在此处可设置粘贴板内数据，数据是传递给 app 的参数进，
                                // console.log("---------------launch", e.detail);
                            });
                            btn.addEventListener("error", (e) => {
                                // 在此处可设置粘贴板内数据，数据是传递给 app 的参数进，
                                // console.log("---------------fail", e.detail);
                                that.gotoLoginFun();
                            });
                    }, 100);
                    setTimeout(() => {
                        if(that.loginFlag==false){
                            that.isAndroidShow=false;
                        }
                    }, 1000);
                
                }
            });
        },
        deactivated() { //离开这个界面之后，删除滚动事件，不然容易除bug
            let that = this;
            // window.removeEventListener('scroll', this.handleScroll)
            that.scrollFalg = that.scrollTop;
            that.scrollJumpFalg = true;
    
        },
        destroyed() {
            scMdFunc('alPageLeave', {
                cur_page: '5',
                ...this.scData
            })
        },
        mounted() {
            this.isAndroidShow = navigator.userAgent.match("Android");
            let that = this;
            if (isWeixin()) {
                    this.isWx = true;
            }
          
            // if (isWeixin()) {
            //     this.isWx = true;
            // }
            // this.uid = this.getCookie('_at_pt_0_') && this.getCookie('_at_pt_0_') > 0 ? this.formatZero(this.getCookie('_at_pt_0_')) : 0;
            // this.headerImg = this.getCookie('_at_pt_0_') && this.getCookie('_at_pt_0_') > 0 ? 'https://img12' + '.artimg.net/passport/avatar/' + this.uid.substring(0, 3) + '/' + this.uid.substring(3, 6) + '/' + this.uid.substring(6, 9) + '/150_150.png?t=' + new Date().getTime() : '';
            // var isTuluApp = (/(SwiftTuLu|ArtronTulu|HarmonyOSTulu)/g).test(window.navigator.userAgent)
            // var isToutiaoApp = (/(SwiftToutiao|ArtronToutiao|ArtExpress)/g).test(window.navigator.userAgent)
            // if (isTuluApp || isToutiaoApp) {
            //     this.noJump = false
            // }
            // // this.getPodData();
            // if (!this.getIsLoadIng) {
            //     this.keyWordls.specialCode = this.$route.params.specialCode;
            //     if (this.$route.query.from && this.$route.query.from == 1) {
            //         this.keyWordls.show = 1;
            //     }
            //     this.getAudience([
            //         this.keyWordls,
            //         () => {
            //             this.filteData();
            //         },
            //     ]);
            // } else {
            //     this.filteData();
            // }
    
        },
        asyncData({
            store,
            route
        }) {
            var dataJSON = {};
            if (route.query.from) {
                if (route.query.from == 1 || route.query.from == 2) {
                    dataJSON = {
                        isAppraise: 0,
                        isBigPic: 0,
                        keyword: "",
                        orderby: 0, //估价和lot
                        page: 1,
                        specialCode: route.params.specialCode,
                        only_meta: 1,
                        show: 1,
                    };
                }
            } else {
                dataJSON = {
                    isAppraise: 0,
                    isBigPic: 0,
                    keyword: "",
                    orderby: 0, //估价和lot
                    page: 1,
                    specialCode: route.params.specialCode,
                    only_meta: 1,
                };
            }
            return store.dispatch("pageSpecial/getAudience", [
                dataJSON,
                null,
                () => {},
            ]);
        },
        components: {
            emptyPage,
            lottie,
            panel,
            DownLoadApp,
            watermark,
            contact
        },
    };
    </script>
    
    <style lang="scss" scoped>
    @import url("../../assets/css/reset.css");
    @import url("../../assets/css/swiper.css");
    .custom-container {
            ::v-deep .van-dialog__footer{
                padding: 0.8rem;
                justify-content:space-between;
            }
            ::v-deep .van-hairline--top::after,::v-deep .van-hairline--left::after{
                border: none;
            }
            ::v-deep .van-dialog__header{
                font-family: PingFang SC, PingFang SC;
                font-weight: 600;
                font-size: 0.85rem;
                color: #000000;
            }
            ::v-deep .van-dialog__message{
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 0.75rem;
                color: #6B6C6C;
                margin-top: 0.8rem;
            }
            ::v-deep.van-dialog__cancel {
                background: #F5F5F5;
                border-radius: 2.3rem 2.3rem 2.3rem 2.3rem;
                font-family: PingFang SC, PingFang SC;
                font-weight: 600;
                font-size: 0.7rem;
                color: #6B6C6C;
                margin-right: 0.8rem;
            }
            ::v-deep .van-dialog__confirm {
                background: #009B5F;
                border-radius: 2.3rem 2.3rem 2.3rem 2.3rem;
                font-family: PingFang SC, PingFang SC;
                font-weight: 600;
                font-size: 0.7rem;
                color: #FFFFFF;
            }
         }
    .auction-detail-info-list {
     
        .title {
            background: #009B5F;
            padding: 0 .7rem;
            height: 2rem;
            display: flex;
            align-items: center;
            font-size: 0.7rem;
            font-weight: 600;
            color: #FFFFFF;
    
            .item {
                flex: 1;
            }
        }
    
        .blackStyle {
            height: auto !important;
            padding: 0 !important;
    
            .item {
                line-height: 1.5rem;
                border: 1px solid #333;
                text-align: center;
            }
        }
    
        .row {
            padding: 0 .7rem;
            height: 2rem;
            display: flex;
            align-items: center;
            font-size: 0.65rem;
            font-weight: 400;
            color: #000000;
    
            .item {
                flex: 1;
            }
    
            &:nth-child(odd) {
                background: rgba(0, 155, 95, 0.05);
            }
        }
    
        .desc {
            text-align: center;
            font-size: 0.6rem;
            font-weight: 400;
            color: #949596;
            line-height: 0.7rem;
            margin: .5rem 0 1rem;
        }
    }
    
    .liveStatus {
        position: absolute;
        background-color: rgba(255, 255, 255, 0.9);
        border-radius: 0.5rem;
        padding: 0.5rem;
        font-size: .5rem;
        line-height: .7rem;
        color: #27282d;
        top: 8.25rem;
        right: 0.55rem;
        text-align: center;
        z-index: 999;
    
        .liveIconSty {
            display: inline-block;
            vertical-align: middle;
            background: #F6344B;
            border-radius: 0.7rem;
            margin-bottom: 0.2rem;
            padding: 0.2rem;
        }
    }
    
    .userMsgBox {
        width: 100%;
        text-align: center;
        padding-top: 0.4rem;
        font-size: 0.6rem;
        height: 1.8rem;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #B97D3D;
    
        img {
            width: 1.5rem;
            height: 1.5rem;
            border-radius: 1.5rem;
            margin-right: 0.3rem;
            vertical-align: middle;
        }
    
    }
    
    .page {
        width: 18.75rem;
        margin: 0 auto;
    }
    
    .header {
        height: 2.2rem;
        background: #ffffff;
    }
    
    .greenHeader {
        background: rgba(0, 0, 0, 0);
        position: relative;
        z-index: 2;
    }
    
    .followBox {
    
        position: absolute;
        right: 2.5rem;
        top: 0.1rem;
    
        img {
            width: 2rem;
            vertical-align: top;
        }
    
    }
    
    .header h3 {
        margin-left: 2.2rem;
        margin-right: 2.2rem;
        text-align: center;
        font-size: 0.9rem;
        line-height: 2.2rem;
        color: #27282d;
    }
    
    .openTool {
        display: inline-block;
        width: 2.4rem;
        box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.08);
        border-radius: 8px 8px 8px 8px;
        background: #fff;
        padding: 0.3rem;
        text-align: center;
        margin-bottom: 0.7rem;
        position: relative;
    
        img {
            width: 1.5rem;
            height: 1.5rem;
        }
    
        .toolVipIcon {
            width: 0.7rem;
            height: 0.7rem;
            right: 0.8rem;
            bottom: 1.3rem;
            position: absolute;
        }
    
        span {
            display: inline-block;
            margin-top: 0.2rem;
            font-size: 0.5rem;
        }
    
    }
    
    .header .goBack {
        float: left;
        width: 2.2rem;
        height: 2.2rem;
        background: url(../../assets/img/icon_nav_return_light@2x.png) no-repeat;
        background-size: cover;
    }
    
    .header .icon_share {
        width: 2.2rem;
        height: 2.2rem;
        float: right;
        background: url("../../assets/img/icon_nav_share_white@3x.png") no-repeat;
        background-size: cover;
    }
    
    .greenHeader .goBack {
        float: left;
        width: 2.2rem;
        height: 2.2rem;
        background: url(../../assets/img/icon_nav_return_white@2x.png) no-repeat;
        background-size: cover;
    }
    
    .imgBg {
        width: 100%;
        height: 20.4rem;
        position: absolute;
        z-index: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.2);
        overflow: hidden;
    
        .bgGary {
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 1;
            background: rgba(0, 0, 0, 0.2);
        }
    }
    
    .imgBg img {
        width: 100%;
        height: 100%;
        filter: blur(20px);
    }
    
    .aucInfos {
        // background: #35BD7D;
        // border-top: 1px solid #35BD7D;
    }
    
    .aucInfos dl {
        padding: 0 0.5rem 0.5rem;
    }
    
    .aucInfos dt {
        float: left;
        width: 4.35rem;
        height: 5.8rem;
        box-shadow: 0rem 0rem 0.35rem 0rem rgba(0, 0, 0, 0.35);
        overflow: hidden;
    }
    
    .aucInfos dt .imgCenter {
        width: 100%;
        height: 100%;
        background: #d8d8d8;
        position: relative;
    
        a {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
        }
    
        .live,
        .review {
            position: absolute;
            display: block;
            height: 1rem;
            line-height: 1rem;
            padding: 0 .3rem;
            background: rgba(0, 0, 0, .4);
            font-size: 0.6rem;
            border-radius: .5rem;
            white-space: nowrap;
            color: #ffffff;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
    }
    
    .aucInfos dt .imgCenter img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    
    .aucInfos dd {
        margin-left: 4.85rem;
    }
    
    .aucInfos dd .name {
        font-size: 0.7rem;
        line-height: 1.1rem;
        color: #ffffff;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        max-height: 2.2rem;
        z-index: 1;
        position: relative;
    }
    
    .aucInfos dd .tags {
        margin-top: 0.4rem;
        font-size: 0;
        position: relative;
    }
    
    .aucInfos dd .tag {
        display: inline-block;
        vertical-align: middle;
        padding: 0 0.2rem;
        border: 0.03rem solid #ffffff;
        border-radius: 0.1rem;
        height: 0.8rem;
        font-size: 0.55rem;
        line-height: 0.8rem;
        color: #ffffff;
        margin-right: 0.3rem;
    }
    
    .aucInfos dd .tagStyle {
        color: #FFFFFF;
        border: 0;
        background: linear-gradient(87deg, #FB9C57 0%, #F22C2C 100%), rgba(0, 155, 95, 0.05);
    }
    
    .aucInfos dd .items {
        margin-top: 0.6rem;
        font-size: 0.55rem;
        color: #ffffff;
        line-height: 1.15rem;
        // background: url(../../assets/img/icon_white_arrow.png) no-repeat right center;
        // background-size: .8rem auto;
    }
    
    .aucInfos dd .items p {
        position: relative;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding-right: 0.8rem;
    }
    
    .aucInfos dd .items p span {
        margin-right: 0.5rem;
    }
    
    .aucInfos dd .items p .arrow {
        position: absolute;
        right: 0;
        top: 0.2rem;
        width: 0.8rem;
        height: 0.8rem;
        background: url(../../assets/img/icon_white_arrow.png) no-repeat;
        background-size: cover;
    }
    
    .listWrap {
        padding-bottom: 3rem;
        position: relative;
    }
    
    .listWrap .listNum {
        height: 2rem;
        padding: 0.5rem 0.75rem 0;
        position: relative;
        background: #ffffff;
    }
    
    .listWrap .listNum h4 {
        font-size: 0.7rem;
        line-height: 1.5rem;
        color: #969696;
    }
    
    .listWrap .listNum .lotNum {
        margin-left: 0.75rem;
    }
    
    .specialSubjectBox {
        padding-top: 0.6rem;
        background-image: linear-gradient(#fff, #fff);
        width: 100%;
        z-index: 2;
        position: relative;
    }
    .greenTip{
        background: rgba(0,155,95,0.05);
        border-radius: 8px 8px 8px 8px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 13px;
        color: #009B5F;
        width: calc(100% - 1.6rem);
        padding: 0.4rem 0.55rem;
        margin: 0 0.8rem;
        display: flex;
        align-items: center;

    }
    
    .subjectBox {
        width: 100%;
        background: #fff;
        border-top-right-radius: 1rem;
        border-top-left-radius: 1rem;
        padding: 0.6rem 0.6rem 0.2rem 0.6rem;
    }
    
    .bidTypeBox {
        background-image: url("../../assets/img/Group521@2x.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        border-radius: 0.7rem;
        opacity: 1;
        width: 100%;
        border: 1px solid rgba(0, 155, 95, 0.7);
    }
    
    .bottomPopup {
        border-top-left-radius: 1rem;
        border-top-right-radius: 1rem;
    
        .popup {
            padding: 0 2rem;
            margin-bottom: 0.5rem;
    
            .tabTitle {
                background: #009B5F;
                color: #FFFFFF;
                font-weight: bolder;
                text-align: left;
                padding: 0.5rem;
            }
    
            .tabText {
                color: #000000;
                text-align: left;
                background: #F2FAF7;
                padding: 0.5rem;
    
                &:nth-child(2n) {
                    background: #fff;
                }
            }
    
        }
    
        .popupTitle {
            width: 100%;
            text-align: center;
            padding: 0.7rem 0;
            font-size: 0.8rem;
            font-weight: border;
            color: #000000;
        }
    
        .popupDest {
            width: 100%;
            font-size: 0.6rem;
            color: #949596;
            text-align: center;
        }
    }
    
    .bidMainBtnBox {
        margin: 1rem 0;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
    
        div {
            color: #6B6C6C;
            display: inline-block;
            width: 30%;
            text-align: center;
            font-size: 0.6rem;
            border: 1px solid rgba(0, 0, 0, 0.3);
            border-radius: 0.7rem;
            padding: 0.3rem 0.5rem;
    
        }
    }
    
    .bidMainTextBox {
        color: #6B6C6C;
        font-size: 0.6rem;
        padding: 0 0.7rem;
        display: flex;
    
        div {
            display: inline-block;
            min-width: calc(35% - .7rem);
            margin-right: 3%;
            text-align: center;
    
            img {
                width: 0.5rem;
                vertical-align: revert;
            }
        }
    
        span {
            font-weight: bolder;
            color: #000000;
            width: 100%;
            display: inline-block;
        }
    
    }
    
    .bidTitleBox {
        padding: 0.5rem  0.7rem  0.7rem  0.3rem;
        display: flex;
        align-items: center;
        position: relative;
        justify-content: flex-start;
    
        .bitTypeIcon {
            height: .7rem;
        }
    
        .bidText {
            color: #000;
            font-weight: bolder;
            font-size: .8rem;
            margin-left: 0.5rem;
        }
    
        .bidkaiboBtn {
            right: 1rem;
            position: absolute;
            padding: 0rem 0.5rem;
            border-radius: 1rem;
            line-height: 1rem;
            color: #009B5F;
            font-size: 0.6rem;
            border: 1px solid #009B5F;
        }
    }
    
    .subjectContentBox {
        height: 52px;
        margin-top: 0.3rem;
        background: #F7F8F9;
        border-radius: 6px 6px 6px 6px;
        overflow: hidden;
        padding: 6px;
        box-sizing: border-box;
    }
    
    .subjectImg {
        width: 71px;
        height: 40px;
        border-radius: 4px 4px 4px 4px;
        overflow: hidden;
        display: inline-block;
    }
    
    .subjectImg img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    
    .subjectTextBox {
        display: inline-block;
        font-size: 0.65rem;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        /* line-height: 16px; */
        vertical-align: top;
        width: calc(100% - 85px);
    }
    
    .subjectTextBox div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    
    .subjectTextBox .num {
        font-size: 0.55rem;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #949596;
        line-height: 20px;
    }
    
    .searchBtn {
        position: absolute;
        top: 0.4rem;
        left: 2rem;
        width: 12rem;
        height: 1.3rem;
        border-radius: 1.5rem;
        background: #2CAB6D;
        padding: 0 0.6rem;
        line-height: 1.4rem;
        color: #fff;
        font-size: 0.5rem;
    }
    
    .searchBtn .searchIcon {
        display: inline-block;
        vertical-align: -0.1rem;
        width: 0.7rem;
        height: 0.7rem;
    
        margin-right: 0.3rem;
    }
    
    .podWrap {
        position: fixed;
        right: 0;
        bottom: 7.35rem;
        width: 3.2rem;
        height: 6.4rem;
        background: transparent;
        z-index: 30;
    }
    
    .podWrap .podReviewBtn {
        width: 3.2rem;
        height: 3.2rem;
        background: url("../../assets/img/icon_lots_pod_review.png") no-repeat center center;
        background-size: 100% 100%;
    }
    
    .podWrap .podBuyBtn {
        width: 3.2rem;
        height: 3.2rem;
        background: url("../../assets/img/icon_lots_pod_buy.png") no-repeat center center;
        background-size: 100% 100%;
    }
    
    .navBar {
        height: 1.75rem;
        padding-left: 1.15rem;
        padding-right: 0.9rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #ffffff;
    }
    
    .navBar .navItem {
        font-size: 0.7rem;
        color: #27282d;
        line-height: 1.75rem;
        position: relative;
    }
    
    .navBar .orderItem {
        padding-right: 0.6rem;
    }
    
    .navBar .orderItem::before {
        content: "";
        position: absolute;
        width: 0.3rem;
        height: 0.3rem;
        right: 0;
        top: 0.55rem;
        background: url(../../assets/img/grey_up.png) no-repeat;
        background-size: cover;
    }
    
    .navBar .orderItem::after {
        content: "";
        position: absolute;
        right: 0;
        bottom: 0.55rem;
        width: 0.3rem;
        height: 0.3rem;
        background: url(../../assets/img/grey_down.png) no-repeat;
        background-size: cover;
    }
    
    .navBar .active {
        color: #35bd7d;
    }
    
    .navBar .up::before {
        background-image: url(../../assets/img/green_up.png);
    }
    
    .navBar .down::after {
        background-image: url(../../assets/img/green_down.png);
    }
    
    .speList {
        border-top: 0.05rem solid #e7e7e7;
        background: #ffffff;
    }
    
    .speList ul {
        padding: 0 0.75rem;
    }
    
    .speList li {
        padding: 0.75rem 0;
        border-bottom: 0.05rem solid #dddee3;
    }
    
    .speList li:last-child {
        border-bottom: none;
    }
    
    .speList li dt {
        width: 3.75rem;
        height: 5rem;
        border-radius: 0.2rem;
        overflow: hidden;
        position: relative;
        float: left;
    }
    
    .speList li dt .imgCenter {
        width: 100%;
        height: 100%;
        display: flex;
        background: #f5f5f5;
    }
    
    .speList li dt .imgCenter .showTypeBox {
    
        position: absolute;
        bottom: 10px;
        left: 10px;
        width: 25px;
        height: 25px;
        background: rgba(121, 123, 123, 0.3);
        border-radius: 3rem;
        padding: 0.1rem 0 0 0;
    
    }
    
    .speList li dt .imgCenter img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    
    .speList li dd {
        margin-left: 4.25rem;
        position: relative;
    }
    
    .speList dd .addTulu {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        height: 1rem;
        border-radius: 0.5rem;
        border: 0.05rem solid #18bd6f;
        padding: 0 0.5rem;
        font-size: 0.5rem;
        line-height: 1rem;
        color: #18bd6f;
        z-index: 1;
    }
    
    .speList li dl {
        overflow: hidden;
    }
    
    .speList li dd h3 {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        font-size: 0.8rem;
        line-height: 1.1rem;
        /* height: 2.2rem; */
        margin-bottom: 0.5rem;
        min-height: 1.45rem;
        color: #27282d;
    }
    
    .speList li dd h3 .status {
        width: 1.9rem;
        height: 0.7rem;
        display: inline-block;
        vertical-align: -0.1rem;
        margin-right: 0.2rem;
    }
    
    .speList li dd h3 .status1 {
        background: url(../../assets/img/icon_list_tag_green@2x.png) no-repeat;
        background-size: cover;
    }
    
    .speList li dd h3 .status2 {
        background: url(../../assets/img/icon_list_tag_red@2x.png) no-repeat;
        background-color: rgba(235, 81, 100, 0.10);
        background-position: center;
        background-size: 80% 70%;
        height: 0.8rem;
    }
    
    .speList li dd h3 .status3 {
        background: url(../../assets/img/icon_list_tag_grey@2x.png) no-repeat;
        background-color: rgba(188, 189, 190, 0.20);
        background-position: center;
        background-size: 80% 70%;
        height: 0.8rem;
    }
    
    .speList li dd h3 .status4 {
        background: url(../../assets/img/icon_list_tag_green.png) no-repeat;
        background-color: rgba(54, 153, 114, 0.10);
        background-position: center;
        background-size: 80% 70%;
        height: 0.8rem;
    }
    
    .speList li dd h3 .status5 {
        background: url(../../assets/img/icon_list_tag_grey@2x.png) no-repeat;
        background-color: rgba(188, 189, 190, 0.20);
        background-position: center;
        background-size: 80% 70%;
        height: 0.8rem;
    }
    .restrictTransportIcon{
        width: 2.05rem;
        height: 0.9rem;
        display: inline-block;
        vertical-align: -0.1rem;
        margin-left: -0.2rem;
        border-radius: 0.17rem;
        overflow: hidden;
        background: url(../../assets/img/restrictTransport_icon.png) no-repeat;
        background-color: rgba(188, 189, 190, 0.20);
        background-position: center;
        background-size: 100% 100%;
    }
    
    .speList li dd .speInfo {
        position: relative;
    }
    
    .speList li dd .speItem {
        font-size: 0.65rem;
        color: #969696;
        line-height: 0.9rem;
    }
    
    .speList li dd .speItem .item {
        margin-bottom: 0.15rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding-left: 0.95rem;
        background-repeat: no-repeat;
        background-position: left center;
        background-size: 0.65rem;
    }
    
    .speList li dd .speItem:last-child .item {
        margin-bottom: 0;
    }
    
    .speList li dd .speItem .icon1 {
        background-image: url(../../assets/img/icon_lot.png);
    }
    
    .speList li dd .speItem .icon2 {
        background-image: url(../../assets/img/icon_gu.png);
        color: #e93b3d;
    }
    
    .speList li dd .speItem .icon3 {
        background-image: url(../../assets/img/icon_clock.png);
    }
    
    .speList li dd .speItem .icon4 {
        background-image: url(../../assets/img/icon_list_cheng_light@2x.png);
        color: #DD2815;
    }
    
    .speList li dt .num {
        position: absolute;
        top: 0.2rem;
        left: 0.2rem;
        padding: 0 0.2rem;
        border-radius: 0.1rem;
        background: #101415;
        font-size: 0.6rem;
        line-height: 0.75rem;
        color: #ffffff;
    }
    
    .speList li dt .HiPic {
        background: url(../../assets/img/icon_list_HDpic_26@2x.png) no-repeat;
        position: absolute;
        top: 0;
        right: 0;
        width: 1.7rem;
        height: 0.8rem;
        background-size: 100% 100%;
    }
    
    .speList li dt .review {
        position: absolute;
        bottom: 0;
        left: 0;
        text-align: center;
        width: 100%;
        height: 1rem;
        background: rgba(0, 0, 0, 0.85);
        font-size: 0.55rem;
        line-height: 1rem;
        color: #ffffff;
    }
    
    .footBtnBox {
        position: fixed;
        left: 0;
        bottom: 3.5rem;
        width: 100%;
    
        .footBtn {
            width: 7rem;
            line-height: 2rem;
            background: #009B5F;
            box-shadow: 0px 4px 8px 0px rgba(13, 113, 74, 0.2);
            border-radius: 2rem;
            text-align: center;
            font-family: PingFang SC, PingFang SC;
            color: #fff;
            font-weight: 600;
            margin: 0 auto;
    
            img {
                width: 1rem;
                height: 1rem;
                margin-right: 0.2rem;
                vertical-align: middle;
            }
        }
    }
    
    .fixBot {
        position: fixed;
        width: 18.75rem;
        left: 50%;
        margin-left: -9.375rem;
        bottom: 0;
        background: #ffffff;
        box-shadow: 0rem -0.1rem 0.5rem 0rem rgba(0, 0, 0, 0.1);
        z-index: 10;
    
    }
    
    .fixBot .bidIcon {
        width: 2rem;
        color: #6B6C6C;
        text-align: center;
        float: left;
        margin-left: 0.5rem;
        margin-top: 0.5rem;
    
        img {
            width: 1.4rem;
        }
    
        span {
            display: inline-block;
            font-size: 0.6rem;
        }
    }
    
    .liveBtn {
        width: 17.25rem;
        height: 2.2rem;
        margin: 0.4rem auto;
        background: #18bd6f;
        box-shadow: 0rem -0.1rem 0.5rem 0rem rgba(0, 0, 0, 0.1);
        border-radius: 0.2rem;
        text-align: center;
        line-height: 2.2rem;
        font-size: 0.8rem;
        line-height: 2.2rem;
        color: #ffffff;
    
        a {
            color: #fff;
        }
    }
    
    .vipBtnShow {
        display: inline-flex;
        padding: 0 0.75rem;
    
        .liveBtn {
            width: auto;
            padding: 0 .8rem;
    
            &:nth-child(1) {
                margin-right: 0.4rem;
            }
        }
    }
    
    .onlineAuction {
        background: #ffffff;
        padding: 0 0.65rem 0;
        border-top: 1px solid #F8F8F8;
        border-bottom: 1px solid #F8F8F8;
    }
    
    .onlineAuction .auctionView {
        display: block;
        line-height: 1.2rem;
        font-size: .7rem;
        background: url(../../assets/img/icon_pai@2x.png) no-repeat 0 center;
        background-size: auto 1.2rem;
        font-family: Helvetica, STHeiTi, Arial, sans-serif;
        padding: 0.55rem 0 0.55rem 1.45rem;
        width: 100%;
        display: inline-flex;
        justify-content: space-between;
    }
    
    .onlineAuction .auctionView .auctionTitle {
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        vertical-align: middle;
    }
    
    .onlineAuction .auctionView .auctionBtn {
        display: inline-block;
        border: 0.03rem solid #18BD6F;
        border-radius: 0.6rem;
        text-align: center;
        font-size: .5rem;
        color: #18BD6F;
        padding: 0 0.5rem;
        white-space: nowrap;
        min-width: 2.2rem;
    }
    
    .unLoginBox {
        width: 100%;
        height: 38%;
        padding-top: 3rem;
        text-align: center;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 55;
        background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1), rgba(255, 255, 255, 1), rgba(255, 255, 255, 1), white, white);
    
        .unLoginBtn {
            width: 80%;
            height: 2.2rem;
            line-height: 2.2rem;
            background: #000000;
            margin: 1rem auto;
            color: #fff;
            border-radius: 1.2rem;
        }
    
        img {
            margin: .5rem auto;
            width: 4rem;
        }
    }
    </style>
    